<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'TIPOCAUSAL.LBL_TIPOCAUSALES' | translate}}</h1>
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-6 lg:col-6">
  </div>
  <div class="col-12 md:col-6 lg:col-6">
    <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
           (input)="dt.filterGlobal($event.target.value, 'contains')"
           [(ngModel)]="busqueda" (change)="setBusqueda()">
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas" [loading]="carTabla" #dt
             [value]="lisTiposCausales" selectionMode="single" dataKey="idLista"
             [paginator]="true" [rows]="10"  paginatorPosition="bottom">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td>{{row.codigo}}</td>
          <td>{{row.nombre}}</td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                      title="{{'BTN_VISUALIZAR' | translate}}"
                      pButton (click)="ver(row)"></button>
              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                      title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar"
                      (click)="editar(row)"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ 'MSG_NOHAYREGISTROS' | translate}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>


<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false"
           *ngIf="mosDialogo"
          [(visible)]="mosDialogo"
          [contentStyle]="{'width':'800px'}"
          header="{{ 'TIPOCAUSAL.LBL_DETALLECAUSALES'  | translate}}"
          [modal]="true">
  <div class="grid">
    <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOCAUSAL.LBL_CODIGO' | translate }}:</label>
    <label class="lg:col-3 col-6 md:col-8 "><strong>{{tipCausalSeleccionada.codigo}}</strong></label>
    <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOCAUSAL.LBL_NOMBRE' | translate }}:</label>
    <label class="lg:col-3 col-6 md:col-8"><strong>{{tipCausalSeleccionada.nombre}}</strong></label>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="colCausales"
               [value]="lisCausales"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.nombreListaCausalSolicitud}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
              pButton (click)="cerrar()"></button>
    </div>
  </div>
</p-dialog>
